import TypographyRebrand from 'src/components/atoms/TypographyRebrand/TypographyRebrand'
import { ActionBlockRebrandResult } from 'src/components/layouts/Page/SanityContentPage/types'
import { CmsCtaButtonRebrand } from 'src/components/molecules/CmsCtaButtonRebrand'

const PATTERN_SRC = '/img/hero/patterns/patternGreenMarble.png'

export const ActionBlockRebrand = ({
  heading,
  subheading,
  link
}: ActionBlockRebrandResult) => {
  return (
    <section className='relative w-full overflow-hidden'>
      <div
        aria-hidden
        className='absolute inset-0 pointer-events-none bg-cover bg-center'
        style={{ backgroundImage: `url(${PATTERN_SRC})` }}
      />
      <div
        aria-hidden
        className='absolute inset-0 pointer-events-none bg-limeBright/50'
      />
      <div className='container relative mx-auto flex min-h-[398px] flex-col items-center justify-center gap-1.5 px-4 py-9 text-center lg:px-20'>
        <div className='flex flex-col items-center gap-2.5'>
          {heading && (
            <TypographyRebrand variant='h4' color='forestDeep'>
              {heading}
            </TypographyRebrand>
          )}
          {subheading && (
            <TypographyRebrand variant='introduction' color='forestDeep'>
              {subheading}
            </TypographyRebrand>
          )}
        </div>
        {link && <CmsCtaButtonRebrand {...link} colorVariant='lavender' />}
      </div>
    </section>
  )
}

export default ActionBlockRebrand
